namespace TabAurous.ProductDevelopment {
    export interface SpecSheetItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        Iteration?: string;
        ProductId?: number;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        DiscountPer?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        ExportPieces?: number;
        FancyCharges?: number;
        OtherCharges?: number;
        Volume?: number;
        Volume1?: number;
        Volume2?: number;
        RefTransId?: number;
        ImageName?: string;
        Image1?: string;
        Image2?: string;
        Image3?: string;
        Image4?: string;
        Image5?: string;
        Image6?: string;
        Image7?: string;
        Image8?: string;
        Video1?: string;
        Video2?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        ServerDate?: string;
        StatusId?: number;
        Remarks?: string;
        IsDisabled?: boolean;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        HUID?: string;
        StampId?: number;
        MFAmount?: number;
        MF?: number;
        StoneRate?: number;
        OtherRate?: number;
        LedgerName?: string;
        DeptName?: string;
        PartyCode?: string;
        ProductCode?: string;
        ProductName?: string;
        MetalId?: number;
        HasBom?: boolean;
        DesignId?: number;
        DesignName?: string;
        DesignCode?: string;
        BOMDetails?: SpecSheetBOMRow[];
        LaborDetails?: SpecSheetLaborRow[];
        ItemTypeId?: number;
        ItemType?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        MetalColorId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcOnId?: number;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        KaratId?: number;
        ProductSizeId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        VoucherNo?: string;
        TransDate?: string;
    }

    export namespace SpecSheetItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'ProductDevelopment.SpecSheetItems';
        export const deletePermission = 'ProductDevelopment:SpecSheet:Delete';
        export const insertPermission = 'ProductDevelopment:SpecSheet:Add';
        export const readPermission = '*';
        export const updatePermission = 'ProductDevelopment:SpecSheet:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            RefNo = "RefNo",
            Iteration = "Iteration",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            DiscountPer = "DiscountPer",
            GrossAmount = "GrossAmount",
            RefTransItemId = "RefTransItemId",
            ExportPieces = "ExportPieces",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges",
            Volume = "Volume",
            Volume1 = "Volume1",
            Volume2 = "Volume2",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Image1 = "Image1",
            Image2 = "Image2",
            Image3 = "Image3",
            Image4 = "Image4",
            Image5 = "Image5",
            Image6 = "Image6",
            Image7 = "Image7",
            Image8 = "Image8",
            Video1 = "Video1",
            Video2 = "Video2",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            ServerDate = "ServerDate",
            StatusId = "StatusId",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            HUID = "HUID",
            StampId = "StampId",
            MFAmount = "MFAmount",
            MF = "MF",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            LedgerName = "LedgerName",
            DeptName = "DeptName",
            PartyCode = "PartyCode",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            MetalId = "MetalId",
            HasBom = "HasBom",
            DesignId = "DesignId",
            DesignName = "DesignName",
            DesignCode = "DesignCode",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            ItemTypeId = "ItemTypeId",
            ItemType = "ItemType",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            MetalColorId = "MetalColorId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcOnId = "CalcOnId",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            VoucherNo = "VoucherNo",
            TransDate = "TransDate"
        }
    }
}
